import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import layoutReducer from "./layoutSlice";
import userReducer from "./userSlice";
import generalReducer from "./generalSlice";

const userPersistConfig = {
  key: "user",
  version: 1,
  storage,
};
const generalPersistConfig = {
  key: "general",
  version: 1,
  storage,
};

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedGeneralReducer = persistReducer(
  generalPersistConfig,
  generalReducer
);

export const store = configureStore({
  reducer: {
    layoutReducer: layoutReducer,
    userReducer: persistedUserReducer,
    generalReducer: persistedGeneralReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
